import { BaseChannel, ChannelType } from '@/realtime/channels/baseChannel';
// eslint-disable-next-line import/prefer-default-export
export class PrivateCacheChannel extends BaseChannel {
    constructor(suffix) {
        super(ChannelType.PRIVATE_CACHE);
        this.setSuffix(suffix);
    }
}
